import { render, staticRenderFns } from "./ModalWithContent.vue?vue&type=template&id=546bb40a&scoped=true&"
import script from "./ModalWithContent.vue?vue&type=script&lang=ts&"
export * from "./ModalWithContent.vue?vue&type=script&lang=ts&"
import style0 from "./ModalWithContent.vue?vue&type=style&index=0&id=546bb40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546bb40a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardActions,VCardSubtitle,VCardTitle,VDialog})
